import React, { useEffect } from 'react'
import { ProtectedRouteProps } from './ProtectedRouteTypes'
import { Navigate, replace } from 'react-router-dom'
import { useTheme } from '@emotion/react'

const ProtectedRoute = (props: ProtectedRouteProps) => {
    //const accessToken = sessionStorage.getItem('access_token')
    const accessToken = localStorage.getItem('access_token')
    const themeLocal = localStorage.getItem('theme')

    if (!accessToken) {
        // Redirect to login if no valid access token
        return <Navigate to="/login" replace />;
    }
    return <>{props.children}</>
}

export default ProtectedRoute